import { GetPermitToDig_permitToDig_state } from "../operations/queries/__generated__/GetPermitToDig";
import { StateKey } from "./globalTypes";

export const StateKeyList = {
  REQUEST_IN_PROGRESS: {
    key: StateKey.REQUEST_IN_PROGRESS,
    name: "Request In Progress",
  } as GetPermitToDig_permitToDig_state,
  REQUESTED: { key: StateKey.REQUESTED, name: "Requested" } as GetPermitToDig_permitToDig_state,
  REJECTED: { key: StateKey.REJECTED, name: "Rejected" } as GetPermitToDig_permitToDig_state,
  IN_PROGRESS: { key: StateKey.IN_PROGRESS, name: "In Progress" } as GetPermitToDig_permitToDig_state,
  READY_TO_ISSUE: { key: StateKey.READY_TO_ISSUE, name: "Ready To Issue" } as GetPermitToDig_permitToDig_state,
  ISSUED: { key: StateKey.ISSUED, name: "Issued" } as GetPermitToDig_permitToDig_state,
  EXPIRED: { key: StateKey.EXPIRED, name: "Expired" } as GetPermitToDig_permitToDig_state,
  COMPLETED: { key: StateKey.COMPLETED, name: "Completed" } as GetPermitToDig_permitToDig_state,
  CANCELLED: { key: StateKey.CANCELLED, name: "Cancelled" } as GetPermitToDig_permitToDig_state,
} as const;
